import appConfig from "../config/appConfig";

/**
 * Enriches solution links (containing only solutionId) with metadata from appConfig.solutionConfig.
 * This follows the same pattern used in solutionActions.js for solution attachment.
 *
 * @param {Array<{solutionId: string, principalIdentifier: string}>} solutionLinks - Array of solution links with solutionId and principalIdentifier
 * @returns {Array<{id: string, name: string, logoUrl: string|undefined, principalIdentifier: string|undefined}>} - Enriched solution array
 */
export const enrichSolutionsWithMetadata = (solutionLinks) => {
  if (!solutionLinks || !Array.isArray(solutionLinks)) {
    return [];
  }

  const availableSolutions = appConfig.solutionConfig || [];

  return solutionLinks
    .filter((link) => link && link.solutionId) // Filter out entries with undefined/null solutionId
    .map((link) => {
      const solution = availableSolutions.find(
        (s) =>
          s.solutionId &&
          s.solutionId.toUpperCase() === link.solutionId.toUpperCase()
      );

      return {
        id: link.solutionId,
        name: solution?.name || link.solutionId,
        logoUrl: solution?.logoUrl,
        principalIdentifier: link.principalIdentifier
      };
    });
};

/**
 * Look up a solution's friendly name by its ID using appConfig.solutionConfig.
 * Falls back to the raw solutionId if no match is found.
 *
 * @param {string} solutionId - The solution ID to look up (e.g. "VAUTO", "HH_DZ_PROD")
 * @returns {string} - The friendly name or the original ID as fallback
 */
export const getSolutionName = (solutionId) => {
  if (!solutionId) return solutionId;
  const availableSolutions = appConfig.solutionConfig || [];
  const match = availableSolutions.find(
    (s) =>
      s.solutionId && s.solutionId.toUpperCase() === solutionId.toUpperCase()
  );
  return match?.name || solutionId;
};

export default enrichSolutionsWithMetadata;
